// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------- */
/* SHARED */
/* -------- */

img {
  max-width: 100%;
  height: auto;
}

.text-wrap {
  padding: 0 1rem;
}

#splash-page section {
  overflow: hidden;
  padding: var(--section-padding) 3rem;
}

#splash-page h2,
#splash-page h3,
#splash-page h5 {
  margin-top: 0;
  padding-bottom: 0;
  line-height: 1.25;
}

#splash-page h2 {
  margin-bottom: 10px;
}

#splash-page h5 {
  margin-bottom: 0;
}

.container {
  display: flex;
  gap: var(--ce-base-padding-default);
  flex-direction: column;
  padding: 0 var(--ce-base-padding-default);
}
/* Mobile Portrait */
@media only screen and (max-width: 767px) {
  #splash-page section {
    overflow: hidden;
    padding: var(--section-padding) 1rem;
  }

  .col-2 > div:first-of-type {
    padding-bottom: 1em;
  }
  .image-wrap img {
    width: 60vh;
    margin: 0 auto;
    display: block;
  }
  .image-wrap {
    height: 25vh;
    min-height: 200px;
  }
  .text-wrap {
    padding: 0;
  }
}
/* Desktop */
@media only screen and (min-width: 768px) {
  .container {
    max-width: 1100px;
    margin: 0 auto;
  }
  .col-2 {
    flex-direction: row;
  }
  .col-2 > div {
    width: 50%;
  }

  .col-2 > .text-wrap {
    width: 55%;
  }
  .col-2 > .image-wrap {
    width: 45%;
  }

  .container.align-top {
    align-items: flex-start;
  }
  .container.align-center {
    align-items: center;
  }
  .container.align-stretch {
    align-items: stretch;
  }
  .container.align-bottom {
    align-items: flex-end;
  }

  .image-wrap.align-bottom .moving-image {
    position: absolute;
    width: 100%;
  }
}

/* -------- */
/* SECTIONS */
/* -------- */

/* Hero - What is MDH */

#splash-page section.what-is-mdh {
  background: var(--ce-gradient-alpine-overlook);
  padding-top: 0;
}

.what-is-mdh .text-wrap {
  margin-bottom: 2em;
}

.what-is-mdh .what-is-mdh-description {
  margin-bottom: 10px;
}

@media only screen and (max-width: 767px) {
  .what-is-mdh .text-wrap {
    padding-top: 0;
    margin-bottom: 0;
  }

  #splash-page h2 {
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .what-is-mdh .what-is-mdh-description {
    margin-bottom: 0;
  }

  .what-is-mdh .hero-survey-1,
  .what-is-mdh .hero-survey-2 {
    top: 0;
  }

  .what-is-mdh .hero-symptom-shark {
    top: 0;
  }
}

.what-is-mdh .image-wrap {
  position: relative;
}
.what-is-mdh .hero-survey-1,
.what-is-mdh .hero-survey-2 {
  width: 40%;
  top: 10%;
}
.hero-survey-1 {
  left: 0;
}
.hero-survey-2 {
  right: 0;
}
.hero-symptom-shark {
  width: 50%;
  left: 50%;
  top: 0;
  margin-left: -25%;
}

.icon-bullets {
  list-style: none;
  padding: 0;
  margin: 0;
}

.icon-bullets li {
  display: flex;
  align-items: center;
  padding: 1em 0 0 0;
  gap: 15px;
}

#splash-page .icon-bullets h5 {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .icon-bullets {
    padding-top: 0.5em;
  }
  .icon-bullets li {
    padding: 0.5em 0;
  }
}
@media screen and (max-width: 992px) {
  .what-is-mdh .text-wrap {
    margin-bottom: 0;
  }
  .what-is-mdh .image-wrap {
    top: 60%;
  }
}
.icon-wrap {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  flex: none;
  padding: 0;
  align-items: center;
  justify-content: center;
}

.icon-wrap img {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  margin: 0 auto;
}

.image-wrap {
  position: relative;
}

.moving-image {
  position: absolute;
}

/* Trusted By */

.trusted-by {
  border-top: 1px solid var(--ce-grey-10);
  border-bottom: 1px solid var(--ce-grey-10);
  padding: var(--section-padding) 2rem;
}
.trusted-by .header {
  margin: 0 auto 1em auto;
  text-align: center;
  color: var(--ce-grey-55);
}
.trusted-logos {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 7vw;
  row-gap: 4vw;
}

.trusted-logos img {
  max-height: 65px;
  margin: 0 auto;
  display: block;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 767px) {
  .trusted-logos {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    column-gap: 6vw;
    row-gap: 6vw;
  }
  .logo-container {
    width: 120px;
  }
  .trusted-logos img {
    max-height: 50px;
  }
}

/* Symptom Shark */
.symptom-shark {
  background: var(--ce-gradient-evergreen-petrichor);
}

.ss-feature-bullets {
  list-style: outside;
  padding-left: 20px;
}
.ss-feature-bullets li {
  margin-bottom: 0.5em;
}

.symptom-shark .image-wrap .moving-image {
  max-width: 50%;
}
.symptom-shark-1 {
  left: 45%;
  top: 0;
  flex-direction: column;
}
.symptom-shark-1b {
  margin-top: -20%;
}
.symptom-shark-2 {
  left: 5%;
  top: 25%;
}
.symptom-shark-3 {
  left: 45%;
  top: 53%;
}

@media only screen and (max-width: 767px) {
  #splash-page section.symptom-shark {
    padding-bottom: 0;
  }
  .symptom-shark .image-wrap {
    position: relative;
    top: 30px;
  }
  .symptom-shark .image-wrap img {
    position: relative;
    left: 7%;
  }

  .symptom-shark .image-wrap .moving-image {
    max-width: 33.33333%;
  }

  .symptom-shark-1 {
    left: 0%;
    top: 8%;
  }
  .symptom-shark-2 {
    left: 33%;
    top: 15%;
  }
  .symptom-shark-3 {
    left: 66%;
    top: 8%;
  }
}

@media only screen and (min-width: 768px) {
  .symptom-shark-1 {
    top: -5%;
  }
}

/* Detect */

.detect {
  background: var(--ce-white);
}

@media only screen and (min-width: 768px) {
  .detect .container {
    flex-direction: row-reverse;
  }
}

.detect .image-wrap .moving-image,
.detect-dial {
  position: absolute;
  max-width: 50%;
}
.detect-calendar {
  left: 2%;
  top: 20%;
}
.detect-article {
  left: 25%;
  top: 30%;
}
.detect-home {
  left: 45%;
  top: 20%;
}
.detect-dial {
  top: 10%;
  left: 38%;
  width: 50%;
}

@media only screen and (max-width: 767px) {
  .detect .image-wrap {
    top: 20px;
  }
  .detect-calendar {
    top: 10%;
  }
  .detect-article {
    top: 20%;
  }
  .detect-home {
    top: 10%;
  }
  .detect-dial {
    top: 00%;
  }
}

/* PowerMom */

.powermom {
  background: var(--ce-gradient-early-bird);
}

.powermom .image-wrap {
  position: relative;
  top: -30px;
}

.powermom .image-wrap .moving-image,
.powermom-dial {
  position: absolute;
  max-width: 50%;
}
.powermom-1 {
  left: 36%;
  top: 10%;
}
.powermom-2 {
  left: 5%;
  top: 23%;
}
.powermom-dial {
  top: 50%;
  left: 38%;
  width: 50%;
}

@media only screen and (max-width: 767px) {
  .powermom .image-wrap {
    top: 0;
  }
  .powermom .image-wrap .moving-image,
  .powermom-dial {
    max-width: 45%;
  }
}

.app-store {
  text-align: center;
}

.app-stores {
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1em;
}

.app-stores img {
  height: 60px;
  width: auto;
}

/* Login */

.login-section {
  background: var(--ce-gradient-midnight-moon);
  padding: 150px 0;
}

@media only screen and (max-width: 767px) {
  .login-section {
    padding: 80px 20px;
  }
}

.login-section h3 {
  margin-top: 0px;
}

.login-card {
  max-width: 660px;
  margin: 0 auto 5px;
  padding: 50px 70px;
  border-radius: var(--ce-border-radius-default);
  background-color: var(--ce-grey-1);
  box-shadow: var(--ce-card-shadow);
  border: 1px solid var(--ce-grey-20);
}

@media only screen and (max-width: 767px) {
  .login-card {
    padding: 30px;
  }
  .login-card .button-group {
    flex-wrap: wrap;
    padding: var(--ce-base-padding-default) 0;
  }
}

.mdh-logo-login {
  max-width: 240px;
  margin-bottom: 1em;
}

.button-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--ce-base-padding-default);
  padding: var(--ce-base-padding-default) 0;
}
.button-group a {
  min-width: calc(50% - var(--ce-base-padding-default));
}

#splash-page .button-group .primary-action,
#splash-page .button-group .login-button {
  flex: 1;
}

@media only screen and (min-width: 768px) {
  #splash-page .primary-action,
  #splash-page .login-button {
    min-width: 150px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/ParticipantLanding.css"],"names":[],"mappings":"AAAA,aAAa;AACb,WAAW;AACX,aAAa;;AAEb;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;EAGE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,sBAAsB;EACtB,yCAAyC;AAC3C;AACA,oBAAoB;AACpB;EACE;IACE,gBAAgB;IAChB,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,cAAc;IACd,cAAc;EAChB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;AACF;AACA,YAAY;AACZ;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA,aAAa;AACb,aAAa;AACb,aAAa;;AAEb,uBAAuB;;AAEvB;EACE,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,MAAM;EACR;;EAEA;IACE,MAAM;EACR;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;;EAEE,UAAU;EACV,QAAQ;AACV;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;EACV,SAAS;EACT,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,kBAAkB;AAClB;EACE,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,MAAM;EACN,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,QAAQ;AACV;AACA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,QAAQ;IACR,OAAO;EACT;EACA;IACE,SAAS;IACT,QAAQ;EACV;EACA;IACE,SAAS;IACT,OAAO;EACT;AACF;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA,WAAW;;AAEX;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,QAAQ;EACR,QAAQ;AACV;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;AACF;;AAEA,aAAa;;AAEb;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,QAAQ;EACR,QAAQ;AACV;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,MAAM;EACR;EACA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,UAAU;;AAEV;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,yCAAyC;EAC3C;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;AACF","sourcesContent":["/* -------- */\n/* SHARED */\n/* -------- */\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n.text-wrap {\n  padding: 0 1rem;\n}\n\n#splash-page section {\n  overflow: hidden;\n  padding: var(--section-padding) 3rem;\n}\n\n#splash-page h2,\n#splash-page h3,\n#splash-page h5 {\n  margin-top: 0;\n  padding-bottom: 0;\n  line-height: 1.25;\n}\n\n#splash-page h2 {\n  margin-bottom: 10px;\n}\n\n#splash-page h5 {\n  margin-bottom: 0;\n}\n\n.container {\n  display: flex;\n  gap: var(--ce-base-padding-default);\n  flex-direction: column;\n  padding: 0 var(--ce-base-padding-default);\n}\n/* Mobile Portrait */\n@media only screen and (max-width: 767px) {\n  #splash-page section {\n    overflow: hidden;\n    padding: var(--section-padding) 1rem;\n  }\n\n  .col-2 > div:first-of-type {\n    padding-bottom: 1em;\n  }\n  .image-wrap img {\n    width: 60vh;\n    margin: 0 auto;\n    display: block;\n  }\n  .image-wrap {\n    height: 25vh;\n    min-height: 200px;\n  }\n  .text-wrap {\n    padding: 0;\n  }\n}\n/* Desktop */\n@media only screen and (min-width: 768px) {\n  .container {\n    max-width: 1100px;\n    margin: 0 auto;\n  }\n  .col-2 {\n    flex-direction: row;\n  }\n  .col-2 > div {\n    width: 50%;\n  }\n\n  .col-2 > .text-wrap {\n    width: 55%;\n  }\n  .col-2 > .image-wrap {\n    width: 45%;\n  }\n\n  .container.align-top {\n    align-items: flex-start;\n  }\n  .container.align-center {\n    align-items: center;\n  }\n  .container.align-stretch {\n    align-items: stretch;\n  }\n  .container.align-bottom {\n    align-items: flex-end;\n  }\n\n  .image-wrap.align-bottom .moving-image {\n    position: absolute;\n    width: 100%;\n  }\n}\n\n/* -------- */\n/* SECTIONS */\n/* -------- */\n\n/* Hero - What is MDH */\n\n#splash-page section.what-is-mdh {\n  background: var(--ce-gradient-alpine-overlook);\n  padding-top: 0;\n}\n\n.what-is-mdh .text-wrap {\n  margin-bottom: 2em;\n}\n\n.what-is-mdh .what-is-mdh-description {\n  margin-bottom: 10px;\n}\n\n@media only screen and (max-width: 767px) {\n  .what-is-mdh .text-wrap {\n    padding-top: 0;\n    margin-bottom: 0;\n  }\n\n  #splash-page h2 {\n    margin-bottom: 6px;\n    line-height: 1.2;\n  }\n\n  .what-is-mdh .what-is-mdh-description {\n    margin-bottom: 0;\n  }\n\n  .what-is-mdh .hero-survey-1,\n  .what-is-mdh .hero-survey-2 {\n    top: 0;\n  }\n\n  .what-is-mdh .hero-symptom-shark {\n    top: 0;\n  }\n}\n\n.what-is-mdh .image-wrap {\n  position: relative;\n}\n.what-is-mdh .hero-survey-1,\n.what-is-mdh .hero-survey-2 {\n  width: 40%;\n  top: 10%;\n}\n.hero-survey-1 {\n  left: 0;\n}\n.hero-survey-2 {\n  right: 0;\n}\n.hero-symptom-shark {\n  width: 50%;\n  left: 50%;\n  top: 0;\n  margin-left: -25%;\n}\n\n.icon-bullets {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.icon-bullets li {\n  display: flex;\n  align-items: center;\n  padding: 1em 0 0 0;\n  gap: 15px;\n}\n\n#splash-page .icon-bullets h5 {\n  margin-bottom: 0;\n}\n@media only screen and (max-width: 767px) {\n  .icon-bullets {\n    padding-top: 0.5em;\n  }\n  .icon-bullets li {\n    padding: 0.5em 0;\n  }\n}\n@media screen and (max-width: 992px) {\n  .what-is-mdh .text-wrap {\n    margin-bottom: 0;\n  }\n  .what-is-mdh .image-wrap {\n    top: 60%;\n  }\n}\n.icon-wrap {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  flex: none;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-wrap img {\n  max-width: 100%;\n  max-height: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n\n.image-wrap {\n  position: relative;\n}\n\n.moving-image {\n  position: absolute;\n}\n\n/* Trusted By */\n\n.trusted-by {\n  border-top: 1px solid var(--ce-grey-10);\n  border-bottom: 1px solid var(--ce-grey-10);\n  padding: var(--section-padding) 2rem;\n}\n.trusted-by .header {\n  margin: 0 auto 1em auto;\n  text-align: center;\n  color: var(--ce-grey-55);\n}\n.trusted-logos {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  column-gap: 7vw;\n  row-gap: 4vw;\n}\n\n.trusted-logos img {\n  max-height: 65px;\n  margin: 0 auto;\n  display: block;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media only screen and (max-width: 767px) {\n  .trusted-logos {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    column-gap: 6vw;\n    row-gap: 6vw;\n  }\n  .logo-container {\n    width: 120px;\n  }\n  .trusted-logos img {\n    max-height: 50px;\n  }\n}\n\n/* Symptom Shark */\n.symptom-shark {\n  background: var(--ce-gradient-evergreen-petrichor);\n}\n\n.ss-feature-bullets {\n  list-style: outside;\n  padding-left: 20px;\n}\n.ss-feature-bullets li {\n  margin-bottom: 0.5em;\n}\n\n.symptom-shark .image-wrap .moving-image {\n  max-width: 50%;\n}\n.symptom-shark-1 {\n  left: 45%;\n  top: 0;\n  flex-direction: column;\n}\n.symptom-shark-1b {\n  margin-top: -20%;\n}\n.symptom-shark-2 {\n  left: 5%;\n  top: 25%;\n}\n.symptom-shark-3 {\n  left: 45%;\n  top: 53%;\n}\n\n@media only screen and (max-width: 767px) {\n  #splash-page section.symptom-shark {\n    padding-bottom: 0;\n  }\n  .symptom-shark .image-wrap {\n    position: relative;\n    top: 30px;\n  }\n  .symptom-shark .image-wrap img {\n    position: relative;\n    left: 7%;\n  }\n\n  .symptom-shark .image-wrap .moving-image {\n    max-width: 33.33333%;\n  }\n\n  .symptom-shark-1 {\n    left: 0%;\n    top: 8%;\n  }\n  .symptom-shark-2 {\n    left: 33%;\n    top: 15%;\n  }\n  .symptom-shark-3 {\n    left: 66%;\n    top: 8%;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .symptom-shark-1 {\n    top: -5%;\n  }\n}\n\n/* Detect */\n\n.detect {\n  background: var(--ce-white);\n}\n\n@media only screen and (min-width: 768px) {\n  .detect .container {\n    flex-direction: row-reverse;\n  }\n}\n\n.detect .image-wrap .moving-image,\n.detect-dial {\n  position: absolute;\n  max-width: 50%;\n}\n.detect-calendar {\n  left: 2%;\n  top: 20%;\n}\n.detect-article {\n  left: 25%;\n  top: 30%;\n}\n.detect-home {\n  left: 45%;\n  top: 20%;\n}\n.detect-dial {\n  top: 10%;\n  left: 38%;\n  width: 50%;\n}\n\n@media only screen and (max-width: 767px) {\n  .detect .image-wrap {\n    top: 20px;\n  }\n  .detect-calendar {\n    top: 10%;\n  }\n  .detect-article {\n    top: 20%;\n  }\n  .detect-home {\n    top: 10%;\n  }\n  .detect-dial {\n    top: 00%;\n  }\n}\n\n/* PowerMom */\n\n.powermom {\n  background: var(--ce-gradient-early-bird);\n}\n\n.powermom .image-wrap {\n  position: relative;\n  top: -30px;\n}\n\n.powermom .image-wrap .moving-image,\n.powermom-dial {\n  position: absolute;\n  max-width: 50%;\n}\n.powermom-1 {\n  left: 36%;\n  top: 10%;\n}\n.powermom-2 {\n  left: 5%;\n  top: 23%;\n}\n.powermom-dial {\n  top: 50%;\n  left: 38%;\n  width: 50%;\n}\n\n@media only screen and (max-width: 767px) {\n  .powermom .image-wrap {\n    top: 0;\n  }\n  .powermom .image-wrap .moving-image,\n  .powermom-dial {\n    max-width: 45%;\n  }\n}\n\n.app-store {\n  text-align: center;\n}\n\n.app-stores {\n  max-width: 400px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 1em;\n}\n\n.app-stores img {\n  height: 60px;\n  width: auto;\n}\n\n/* Login */\n\n.login-section {\n  background: var(--ce-gradient-midnight-moon);\n  padding: 150px 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .login-section {\n    padding: 80px 20px;\n  }\n}\n\n.login-section h3 {\n  margin-top: 0px;\n}\n\n.login-card {\n  max-width: 660px;\n  margin: 0 auto 5px;\n  padding: 50px 70px;\n  border-radius: var(--ce-border-radius-default);\n  background-color: var(--ce-grey-1);\n  box-shadow: var(--ce-card-shadow);\n  border: 1px solid var(--ce-grey-20);\n}\n\n@media only screen and (max-width: 767px) {\n  .login-card {\n    padding: 30px;\n  }\n  .login-card .button-group {\n    flex-wrap: wrap;\n    padding: var(--ce-base-padding-default) 0;\n  }\n}\n\n.mdh-logo-login {\n  max-width: 240px;\n  margin-bottom: 1em;\n}\n\n.button-group {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--ce-base-padding-default);\n  padding: var(--ce-base-padding-default) 0;\n}\n.button-group a {\n  min-width: calc(50% - var(--ce-base-padding-default));\n}\n\n#splash-page .button-group .primary-action,\n#splash-page .button-group .login-button {\n  flex: 1;\n}\n\n@media only screen and (min-width: 768px) {\n  #splash-page .primary-action,\n  #splash-page .login-button {\n    min-width: 150px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
